import { IconReactionType, ReactionTargetType } from "@/API";
import { User } from "./user";

export class Reaction {
}

export type IconReaction = {
    __typename: "IconReaction",
    type: IconReactionType,
    targetType: ReactionTargetType,
    domainId: string,
    topicId: string,
    messageId: string,
    commentId: string,
    userList: {
        userId: string,
        updatedAt: string,
    }[],
}

export type DbReaction = {
    __typename: "Reaction",
    type: IconReactionType,
    targetType: ReactionTargetType,
    domainId: string,
    topicId: string,
    messageId: string,
    commentId: string,
    userId: string,
    deletion: number,
    createdAt: string,
    updatedAt: string,
}

export type FavoriteModalUser = {
    user: User,
    updatedAt: string,
}

export const normalizeIconReaction = ( dbReaction: DbReaction ): IconReaction => {
    const reaction: IconReaction = {
        __typename: "IconReaction",
        type: dbReaction.type,
        targetType: dbReaction.targetType,
        domainId: dbReaction.domainId,
        topicId: dbReaction.topicId,
        messageId: dbReaction.messageId,
        commentId: dbReaction.commentId,
        userList: [ { userId: dbReaction.userId, updatedAt: dbReaction.updatedAt } ],
    }
    return reaction;
}
